import styled from "styled-components";
import ConservativeAgreementAttachment from "../../../../Inputs/ConservativeAgreementAttachment";
import { useState } from "react";
import {
  PracticeAttachment,
  useLazyGetConservativeAgreementFileQuery,
} from "../../../../../redux/apiSpecifications/apiCrud";
import { addMimeType } from "../../../../../utils/base64";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

const AttachmentsWrapper = styled.div`
  width: "auto";
  display: flex;
  flex-direction: column;
  align-items: "center";
  justify-content: center;
  width: 12em;
  text-align: center;
  font-size: 0.9em;
`;

const AttachmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  .ant-upload-list-item-actions {
    a {
      display: none;
    }
  }
  .type-name {
    margin-top: 1em;
    text-transform: uppercase;
    font-size: 0.9em;
  }
`;

const FilesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

const PreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4em 2em;
  height: 80vh;
`;

interface IAppraisalConservativeAgreementProps {
  idPractice: number;
}

const AppraisalConservativeAgreement = ({
  idPractice,
}: IAppraisalConservativeAgreementProps) => {
  const [filePreview, setFilePreview] = useState<boolean>(false);

  const [attachment, setAttachment] = useState<PracticeAttachment | undefined>(
    undefined
  );

  const { authorization } = useSelector((state: RootState) => state.user);

  const [getGetConservativeAgreement, result] =
    useLazyGetConservativeAgreementFileQuery();

  const handleOnDownloadFile = async () => {
    setAttachment(undefined);

    const response = await getGetConservativeAgreement({
      authorization,
      id: idPractice,
    });

    if (response.isSuccess && response.data) {
      const practiceAttachment = response.data as PracticeAttachment;

      setAttachment({
        ...practiceAttachment,
        base64File: addMimeType(
          practiceAttachment.base64File!,
          practiceAttachment.originalName!
        ),
      });
    }
  };

  const handleOnPreviewFile = async () => {
    setAttachment(undefined);

    const response = await getGetConservativeAgreement({
      authorization,
      id: idPractice,
    });

    if (response.isSuccess && response.data) {
      const practiceAttachment = response.data as PracticeAttachment;

      setAttachment({
        ...practiceAttachment,
        base64File: addMimeType(
          practiceAttachment.base64File!,
          practiceAttachment.originalName!
        ),
      });
    }

    setFilePreview(true);
  };

  const renderFilePreview = () => {
    if (!attachment || attachment === null) return;

    return (
      <embed
        src={attachment.base64File}
        style={{ width: "100%", height: "100%" }}
      />
    );
  };

  return (
    <AttachmentsWrapper>
      <AttachmentsContainer>
        <FilesContainer>
          <ConservativeAgreementAttachment
            isLoading={result.status === "pending"}
            attachment={attachment}
            onDownload={handleOnDownloadFile}
            onPreview={handleOnPreviewFile}
          />
        </FilesContainer>

        <Modal
          open={filePreview}
          onCancel={() => setFilePreview(false)}
          footer={null}
          width="80%"
        >
          <PreviewWrapper>{filePreview && renderFilePreview()}</PreviewWrapper>
        </Modal>
      </AttachmentsContainer>
    </AttachmentsWrapper>
  );
};

export default AppraisalConservativeAgreement;
